import React from "react";

// ==== Import Images ====
import aboutBg from "../../../images/bg/about-bg02.png";
import aeris from "../../../images/hero/aeris.png";
import kotLogo from "../../../images/logo/kot-logo-white.png";

// KOT Enterprises — Corporate Statutes (Chapters 1–6)
const beliefs = [
  "Technology should empower people rather than replace them.",
  "Artificial Intelligence should augment human intelligence while maintaining ethical responsibility.",
  "Innovation should create measurable value for society.",
  "Entrepreneurship is a catalyst for economic growth and job creation.",
  "Education is the foundation of long-term national competitiveness.",
  "Collaboration between government, academia, industry, investors, and communities creates stronger innovation ecosystems.",
  "Sustainable transformation requires continuous learning, adaptability, and responsible leadership.",
];

const AboutSection: React.FC = () => {
  return (
    <section className="about pos-rel pb-140">

      <div className="container">
        {/* ===== Aeris + KOT logo hero (trendy) ===== */}
        <div className="xb-about-hero wow fadeInUp" data-wow-duration="700ms">
          <span className="xb-about-hero--glow"></span>
          <img className="xb-about-hero--aeris" src={aeris} alt="Aeris — KOT" />
          <img className="xb-about-hero--logo" src={kotLogo} alt="KOT Enterprises" />
        </div>

        {/* ===== Title / Intro (Corporate Statutes — Chapter 1) ===== */}
        <div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
          <span className="sub-title mb-10">Who We Are?</span>

          <h2 className="title">
            A strategic holding company building an ecosystem of companies,
            platforms and institutions
          </h2>

          <p className="content">
            KOT Enterprises (Private) Limited is established as a strategic
            holding company whose primary purpose is to create sustainable
            economic, technological, educational, and social value through
            innovation, intelligent technologies, entrepreneurship, capability
            development, and transformational leadership.
          </p>
          <p className="content mt-20">
            Unlike conventional organizations that focus on delivering products
            or services within a single industry, KOT Enterprises exists to
            build an integrated ecosystem of specialized companies, platforms,
            institutions, and initiatives that collectively solve complex
            national and global challenges — enabling businesses, governments,
            educational institutions, entrepreneurs, and communities to thrive
            in the Intelligent Era.
          </p>
        </div>

        {/* ===== Nature of the Organization ===== */}
        <div className="row justify-content-center mt-20">
          <div className="col-lg-10">
            <div className="xb-about-statement xb-border">
              <p>
                KOT Enterprises is not a traditional software company. It
                functions as a <strong>Future Enterprise Organization</strong>{" "}
                whose responsibility extends beyond software development into the
                creation of intelligent businesses, digital ecosystems,
                education systems, innovation platforms, and economic
                transformation initiatives — built on the convergence of
                Artificial Intelligence, Digital Transformation, Human
                Capability Development, Innovation, Entrepreneurship, Knowledge
                Creation, and Sustainable Economic Development.
              </p>
            </div>
          </div>
        </div>

        {/* ===== Vision / Mission / Purpose (Chapters 2–5) ===== */}
        <div className="row mt-40">
          {/* 1 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Our Vision</h2>
                  <p className="xb-item--content">
                    A future where organizations, industries, governments,
                    entrepreneurs, and communities leverage intelligence,
                    technology, innovation, and human capability to create
                    sustainable prosperity for future generations.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Our Mission</h2>
                  <p className="xb-item--content">
                    To enable organizations, entrepreneurs, and communities to
                    create sustainable economic and social value through
                    intelligent technology, artificial intelligence, education,
                    innovation, and transformational leadership.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 3 */}
          <div className="col-lg-4 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border">
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Our Purpose</h2>
                  <p className="xb-item--content">
                    To create enduring solutions that empower individuals,
                    organizations, institutions, industries, and societies to
                    prosper through innovation, intelligence, education,
                    entrepreneurship, and sustainable transformation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Strategic Direction (Chapter 4) ===== */}
        <div className="row justify-content-center mt-30">
          <div className="col-lg-10">
            <div className="xb-about-direction xb-border">
              <span className="xb-about-direction--label">Strategic Direction</span>
              <p>
                To build organizations, industries, and economies that thrive in
                the Intelligent Era — by establishing specialized companies
                across technology, education, entrepreneurship, commerce,
                creativity, quality assurance, platform economies, and venture
                development. Every subsidiary contributes independently while
                simultaneously strengthening the broader KOT ecosystem.
              </p>
            </div>
          </div>
        </div>

        {/* ===== Corporate Philosophy — Foundational Beliefs (Chapter 6) ===== */}
        <div className="sec-title sec-title-center mt-60 mb-30">
          <span className="sub-title mb-10">Our Corporate Philosophy</span>
          <h2 className="title">Beliefs that guide every decision</h2>
        </div>
        <div className="row mt-none-20">
          {beliefs.map((belief, i) => (
            <div className="col-lg-6 mt-20" key={i}>
              <div className="xb-belief xb-border">
                <span className="xb-belief--num">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p>{belief}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Background */}
      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
